import React from 'react';
import './AboutMe.scss';
import useLanguage from '../../../languages/useLanguage';
import BorderedImage from '../../../blocks/BorderedImage';

function AboutMe() {
  const language = useLanguage();

  return (
    <div className="about-me">
      <div className="about-me-content">
        <div className="introduction">
          <div className="title">{language.aboutMeBody1}</div>
          <div className="subtitle">{language.aboutMeBody2}</div>
          <div className="bold-text">{language.aboutMeBody3}</div>
        </div>
        <div className="about-me-image">
          <BorderedImage borderColor="#d4b466" image="/images/portrait-09.png" />
        </div>
      </div>
      <div className="about-me-main-text">
        <div>{language.aboutMeBody4}</div>
        <div>{language.aboutMeBody5}</div>
        <div>{language.aboutMeBody6}</div>
        <div>{language.aboutMeBody7}</div>
        <div>{language.aboutMeBody8}</div>
        <div>{language.aboutMeBody9}</div>
        <div>{language.aboutMeBody10}</div>
      </div>
    </div>
  );
}

export default AboutMe;
